import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a88a0d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pools-tile" }
const _hoisted_2 = { class: "legend" }
const _hoisted_3 = { style: {"font-weight":"bold"} }
const _hoisted_4 = { class: "items" }
const _hoisted_5 = { class: "legend-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot",
  style: {"background":"#27697F"}
}, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "legend-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot",
  style: {"background":"#FDDB2A"}
}, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1 /* HOISTED */))
const _hoisted_11 = { class: "legend-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot",
  style: {"background":"#72bf44"}
}, null, -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1 /* HOISTED */))
const _hoisted_14 = { style: {"width":"100%"} }
const _hoisted_15 = { style: {"height":"80%","margin-left":"auto","max-width":"1050px","margin-right":"auto"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20% !important"} }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t("DASHBOARD_VIEW.TOKENOMICS")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("DASHBOARD_VIEW.BOUNDED")), 1 /* TEXT */),
          _createVNode(_component_Icon, { name: "ArrowRight" }),
          _createCommentVNode("          <CoinAmount :amount=\"tokensStore.getTotalBonded\" :show-denom=\"true\" style=\"font-weight: bold\"/>"),
          _createVNode($setup["CoinAmount"], {
            amount: new $setup.BigIntWrapper($setup.tokensStore.getTotalBonded),
            "show-denom": true,
            style: {"font-weight":"bold"}
          }, null, 8 /* PROPS */, ["amount"]),
          _createCommentVNode("\n                    <div >\n                      {{ bounded }}\n                    </div> "),
          _hoisted_7,
          _createElementVNode("div", null, [
            _createVNode($setup["PercentsView"], {
              amount: $setup.boundedPercentage,
              precision: 2
            }, null, 8 /* PROPS */, ["amount"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("DASHBOARD_VIEW.UNBOUNDED")), 1 /* TEXT */),
          _createVNode(_component_Icon, { name: "ArrowRight" }),
          _createCommentVNode("          <CoinAmount :amount=\"tokensStore.getTotalUnbonded\" :show-denom=\"true\" style=\"font-weight: bold\"/>"),
          _createVNode($setup["CoinAmount"], {
            amount: new $setup.BigIntWrapper($setup.tokensStore.getTotalUnbonded),
            "show-denom": true,
            style: {"font-weight":"bold"}
          }, null, 8 /* PROPS */, ["amount"]),
          _createCommentVNode(" <div style=\"font-weight: bold\">{{unBounded }}\n          </div> "),
          _hoisted_10,
          _createElementVNode("div", null, [
            _createVNode($setup["PercentsView"], {
              amount: $setup.unboundedPercentage,
              precision: 2
            }, null, 8 /* PROPS */, ["amount"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("DASHBOARD_VIEW.UNBOUNDING")), 1 /* TEXT */),
          _createVNode(_component_Icon, { name: "ArrowRight" }),
          _createCommentVNode("          <CoinAmount :amount=\"tokensStore.getTotalUnbonding\" :show-denom=\"true\" style=\"font-weight: bold\"/>"),
          _createVNode($setup["CoinAmount"], {
            amount: new $setup.BigIntWrapper($setup.tokensStore.getTotalUnbonding),
            "show-denom": true,
            style: {"font-weight":"bold"}
          }, null, 8 /* PROPS */, ["amount"]),
          _hoisted_13,
          _createElementVNode("div", null, [
            _createVNode($setup["PercentsView"], {
              amount: $setup.unboundingPercentage,
              precision: 2
            }, null, 8 /* PROPS */, ["amount"])
          ]),
          _createCommentVNode(" <div style=\"font-weight: bold\">{{ unBounding }}\n          </div> ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode($setup["ShadowedSvgChart"], { id: "tokenchartdiv" }, {
          default: _withCtx(() => [
            _createVNode($setup["VChart"], {
              option: $setup.option,
              autoresize: ""
            }, null, 8 /* PROPS */, ["option"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _hoisted_16
    ])
  ]))
}